import { Controller } from '@hotwired/stimulus';
import { Turbo } from '@hotwired/turbo-rails';
import { useClickOutside } from 'stimulus-use';

export default class extends Controller {
  static targets = ['frame'];

  static values = {
    filterId: String,
    frameId: String,
    modalUrl: String,
    paramName: String,
  };

  connect() {
    useClickOutside(this);
  }

  clickOutside = () => {
    this.close();
  };

  toggle = () => {
    const currentURL = new URL(window.location.href);
    const modalURL = new URL(this.modalUrlValue);

    if (this.frameTarget.hasChildNodes()) {
      this.close();
      return;
    }

    currentURL.searchParams.forEach((value, key) => {
      modalURL.searchParams.append(key, value);
    });

    modalURL.searchParams.set('filter', this.filterIdValue);

    const { id } = this.frameTarget;
    modalURL.searchParams.set('frame', id);

    this.close();
    Turbo.visit(modalURL, { frame: id });
  };

  remove = () => {
    const url = new URL(window.location.href);
    url.searchParams.delete(this.paramNameValue);

    this.close();
    Turbo.visit(url);
  };

  close() {
    // Remove src from frame so that it is not loaded again when the page is
    // restored from cache:
    this.frameTarget.removeAttribute('src');

    // Remove all frame content:
    this.frameTarget.innerHTML = '';
  }
}
